
export default {
    methods: {
        deanDetection(){
            for(var key in this.currentRoleList){
                if(this.currentRoleList.hasOwnProperty(key)){
                    if(this.currentRoleList[key] == "Dean"){
                        console.log(this.currentRoleList)
                        return true
                    }
                }
            }
            return false
        }
    },
}
